class TableRow {
    constructor(items = [], functions = [], properties = {}) {
        this.items = items;
        this.functions = functions;
        this.hasFunctionsForRow = this.functions.length > 0;
        this.properties = new TableRowProperties(properties);
        this.selected = false;
        this.isVisible = true;
    }

    getItems() {
        return this.items;
    }

    getFunctions() {
        return this.functions;
    }

    getAreFunctionsDisabled() {
        return this.properties.areFunctionsDisabled;
    }

    getWhyAreFunctionsDisabled() {
        return this.properties.whyAreFunctionsDisabled;
    }
}

export default TableRow;

class TableRowProperties {
    constructor(properties = {}) {
        this.properties = {
            areFunctionsDisabled: false,
            whyAreFunctionsDisabled: '',
        }

        if (!!Object.keys(properties).length) {
            return {...this.properties, ...properties};
        }

        return this.properties;
    }
}